export const getParameters =`query GetParameters($filter: ParametersRequest!) {
  parameters(filter: $filter) {
    params {
      pkId
      version
      region
      productGroup
      businessGroup
      productFamily
      key
      value
      text
      comments
      status
      whoChanged
      createDate
      lastModifiedDate
      valid
      validationMessage
    }
  }
}`;